import { BehaviorSubject, Observable } from 'rxjs';
import Resource from '@/repositories/Resource';
import User from '@/repositories/data/User';
import networkBoundResource from '@/repositories/networkBoundResource';
import UserApi from '@/repositories/api/UserApi';
import GraphQlApi from '@/repositories/api/GraphQlApi';
import { switchMap } from 'rxjs/operators';
import unwrapGraphQlResponse from '@/repositories/unwrapGraphQlResponse';

export default class UserRepository {
    private readonly userApi: UserApi;
    private readonly graphQlApi: GraphQlApi;

    constructor(userApi: UserApi, graphQlApi: GraphQlApi) {
        this.userApi = userApi;
        this.graphQlApi = graphQlApi;
    }

    public findCurrent(): Observable<Resource<User>> {
        const observable = this.userApi.findSelf().pipe(
            switchMap(user => {
                if (user) {
                    return unwrapGraphQlResponse(this.graphQlApi.getUser());
                }
                return new BehaviorSubject(null).asObservable();
            }),
        );
        return networkBoundResource(observable);
    }

    public keepAlive(): void {
        this.userApi.findSelf().subscribe(() => {
            // Do nothing
        });
    }

    public logout(): Observable<Resource<{ logoutUrl: string }>> {
        const observable = this.userApi.logout();
        return networkBoundResource(observable);
    }
}
